// extracted by mini-css-extract-plugin
module.exports = {"each_row":"Cart_each_row__BG5iQ","img_cart":"Cart_img_cart__3AtSS","qty":"Cart_qty__3qJXi","border":"Cart_border__ankhW"};